import { TRANSACTION_HISTORY } from "api/ApiPath";
import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "api/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { isEmpty } from "lodash";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { AirTimeRegistrationRequestModel } from "./model/AirTimeRegistrationRequestModel";
import { AirTimeRegistrationResponseModel } from "./model/AirTimeRegistrationResponseModel";

export interface IAirTimeRegistrationRepository {
  getList(
    params: AirTimeRegistrationRequestModel
  ): Promise<ListBaseApiResponseModel<AirTimeRegistrationResponseModel>>;
  getDetail(
    params: AirTimeRegistrationRequestModel
  ): Promise<BaseApiResponseModel<AirTimeRegistrationResponseModel>>;
  exportReport(
    params: AirTimeRegistrationRequestModel
  ): Promise<BaseApiResponseModel<Blob>>;
}

@injectable()
export class AirTimeRegistrationImpl implements IAirTimeRegistrationRepository {
  async getList(
    params: AirTimeRegistrationRequestModel
  ): Promise<ListBaseApiResponseModel<AirTimeRegistrationResponseModel>> {
    let queryString = Object?.entries(params)
      ?.filter(
        ([_, vals]) =>
          Array.isArray(vals) && !isEmpty(vals) && !vals?.includes("")
      )
      ?.map(([keys, vals]) => DataFormat.getQueryString(vals, keys))
      ?.join("&");
    DataFormat.removeArrayTypeValue(params);
    return await client?.get(
      `${TRANSACTION_HISTORY.AIRTIMELIST}${
        !isEmpty(queryString) ? `?${queryString}` : ""
      }`,
      params
    );
  }
  async getDetail(
    params: AirTimeRegistrationRequestModel
  ): Promise<BaseApiResponseModel<AirTimeRegistrationResponseModel>> {
    return;
  }
  async exportReport(
    params: AirTimeRegistrationRequestModel
  ): Promise<BaseApiResponseModel<Blob>> {
    let queryString = Object?.entries(params)
      ?.filter(
        ([_, vals]) =>
          Array.isArray(vals) && !isEmpty(vals) && !vals?.includes("")
      )
      ?.map(([keys, vals]) => DataFormat.getQueryString(vals, keys))
      ?.join("&");
    DataFormat.removeArrayTypeValue(params);
    const queryParams = new URLSearchParams(
      params as unknown as URLSearchParams
    )?.toString();
    const url = `${TRANSACTION_HISTORY.AIRTIMELIST}${
      !isEmpty(queryString) ? `?${queryString}` : ""
    }${isEmpty(queryString) ? `?${queryParams}` : `&${queryParams}`}`;
    const token = DataFormat.getToken();
    const alterToken = DataFormat.getAlterToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token ? token : alterToken}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to export report: ${response.statusText}`);
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }
}
